import { useState, useEffect } from 'react'
import { Button, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, Avatar } from '@material-ui/core'

import axiosConfig from '../../../../utils/axiosConfig';

const JoinClassRequestItem = ({request, itemCancelled, closeModal}) => {
    const [cancellingRequest, setCancellingRequest] = useState(false)

    const cancelRequest = async () => {
        setCancellingRequest(true)

        const response = await axiosConfig.get(`/student-requests/${request.student_id}/${request.classroom_id}/cancel`);

        if (response.data.status_code === 'ok') {
            itemCancelled()

            if (response.data.requests.length === 0) {
                closeModal()
            }
        }

        setCancellingRequest(true)
    }

    return (
        <ListItem key={request.id} style={{marginBottom: '10px'}}>
            <ListItemText primary={`${request.classroom.name} ${request.classroom.section} | ${request.classroom.faculty.name}`}/>
            <ListItemSecondaryAction>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        cancelRequest()
                    }}
                >
                    { cancellingRequest ? 'Processing...' : 'Cancel Request' }
                </Button>
            </ListItemSecondaryAction>
        </ListItem>
    )
}

export default JoinClassRequestItem